<template>
    <div>
        <slot :toggle="() => showModal = !showModal" name="activator" />

        <b-modal
                id="completeServicesModal"
                v-model="showModal"
                :title="$t('Mark completed')"
                scrollable
                size="lg"
                @close="reset"
                style="min-height: 300px"
        >
            <template #modal-footer>
                <b-button type="submit" variant="primary" @click="handleSubmit">
                    {{ $t('Save') }}

                    <b-spinner v-if="form.busy" small />
                    <fa v-else class="ml-1" icon="save" />
                </b-button>
            </template>

            <b-form @submit.prevent="handleSubmit">
                <b-form-group
                        :invalid-feedback="form.errors.get('date')"
                        :label="$t('Date')"
                        :label-for="uuid + '_date'"
                        :state="form.errors.has('date') ? false : null"
                >
                    <b-form-datepicker
                            :id="uuid + '_date'"
                            v-model="form.date"
                            :locale="$i18n.locale"
                            :max="$moment().toDate()"
                            :state="form.errors.has('date') ? false : null"
                            class="mb-2"
                            required
                    />
                </b-form-group>

                <b-form-group
                        :invalid-feedback="form.errors.get('staff_member_id')"
                        :label="$t('Staff member')"
                        :label-for="uuid + '_staff_member'"
                        :state="form.errors.has('staff_member_id') ? false : null"
                >
                    <staff-member-select
                            :id="uuid + '_staff_member'"
                            v-model="form.staff_members"
                            :name="uuid + '_staff_member'"
                            :resource="`projects/${projectId}/staff_members`"
                            :state="form.errors.has('staff_member_id') ? false : null"
                            multiple
                    />
                </b-form-group>

                <b-form-group
                        :invalid-feedback="form.errors.get('notice')"
                        :label="$t('Notice')"
                        :state="form.errors.has('notice') ? false : null"
                        label-for="notice"
                >
                    <b-form-textarea
                            id="notice"
                            v-model="form.notice"
                            :state="form.errors.has('notice') ? false : null"
                            name="notice"
                    />
                </b-form-group>

                <b-form-group
                    v-if="!serviceId && !hideServiceSelect"
                    :invalid-feedback="form.errors.get('service_id')"
                    :label="$t('Service')"
                    :state="form.errors.has('service_id') ? false : null"
                    label-for="service_id"
                >
                    <services-select
                        :id="uuid + '_service'"
                        v-model="service"
                        :name="uuid + '_staff_member'"
                        :resource="`projects/${projectId}/available_services`"
                        :state="form.errors.has('service_id') ? false : null"
                        multiple
                        label="formatted_string"
                        @input="onServiceInput"
                    />
                </b-form-group>

                <loading-bar
                        v-if="pending"
                        :absolute="false"
                />

                <slot :form="form" :pending="pending" :services="items" name="services">
                    <template v-if="!serviceId">
                        <tree-view
                                v-model="form.services"
                                :disabled="pending || form.busy"
                                :errors="form.errors"
                                :items="items"
                                :label="$t('Services to complete')"
                                class="mt-3"
                                error-prefix="services"
                                label-by="formatted_string"
                        />
                    </template>
                </slot>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
    import fetchData from "@/mixins/fetchData";
    import Form from "vform";
    import TreeView from "@/components/TreeView";
    import StaffMemberSelect from "@/components/selects/ResourceSelect";
    import ServicesSelect from "@/components/selects/ResourceSelect";

    export default {
        name: 'CompleteServices',
        components: {ServicesSelect, TreeView, StaffMemberSelect},
        mixins: [fetchData],
        props: {
            apiUrl: {
                type: String,
                required: true
            },
            projectId: {
                type: Number,
                required: true
            },
            serviceId: {
                type: Number,
                default: null
            },
            hideServiceSelect: {
                type: Boolean,
                default: false
            },
            lazy: {
              type: Boolean,
              default: true
            }
        },
        data() {
            return {
                form: new Form({
                    date: this.$moment().format('YYYY-MM-DD'),
                    notice: null,
                    services: this.serviceId ? [this.serviceId] : [],
                    service_id: this.serviceId
                }),
                showModal: false,
                service: null,
                params: {
                    service_id: null
                }
            }
        },
        methods: {
            async handleSubmit() {
                if (this.form.busy) return;

                try {
                    await this.form.post(this.apiUrl);
                    this.$emit('services-completed', this.form.data())

                    this.savedToast();

                    this.showModal = false;
                } catch (e) {
                    e.response || throw e;
                }
            },

            onServiceInput($event) {

              if ($event.length > 1) {
                this.params.service_id =  $event.map(x => x.id)
              } else {
                this.params.service_id =  $event[0] ? $event[0].id : null;
              }

              this.$set(this.form,'service_id', this.params.service_id)

            },

            reset() {
                this.form.reset();
                this.items = [];
                this.service = null;
                // this.params = {
                //     service_id: null
                // };
            }
        }

    }
</script>

<style scoped>
 /deep/ .modal-body {
     min-height: 360px;
 }
</style>
